import React, { useEffect, useState } from 'react';
import {
    IonModal, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButton, IonItem, IonIcon, useIonAlert
} from '@ionic/react';
import { trashOutline, cloudUploadOutline } from 'ionicons/icons';
import {
    actionToGetEventGallery,
    actionToUploadEventGallery,
    actionToDeleteEventGalleryImage
} from '../apiHelpers/CommonAction';

const EventGalleryModal = ({ isOpen, eventId, onClose }) => {
    const [files, setFiles] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [loading, setLoading] = useState(false);
    const [presentAlert] = useIonAlert();

    const resetLocal = () => {
        setFiles([]);
        setPreviewUrls([]);
    };

    const loadGallery = async () => {
        if (!eventId) return;
        try {
            const resp = await actionToGetEventGallery(eventId);
            setGallery(resp || []);
        } catch {
            setGallery([]);
        }
    };

    useEffect(() => {
        if (isOpen && eventId) {
            loadGallery();
            resetLocal();
        }
    }, [isOpen, eventId]);

    const onPickFiles = (e) => {
        const f = Array.from(e.target.files || []);
        setFiles(f);
        setPreviewUrls(f.map(file => URL.createObjectURL(file)));
    };

    const onUpload = async () => {
        if (!files.length) return;
        setLoading(true);
        try {
            await actionToUploadEventGallery(eventId, files);
            resetLocal();
            await loadGallery();
        } catch (e) {
            presentAlert({ header: 'Upload failed', message: e?.message || 'Please try again.', buttons: ['OK'] });
        } finally {
            setLoading(false);
        }
    };

    const onDelete = async (id) => {
        presentAlert({
            header: 'Delete image?',
            message: 'This will remove the image from gallery.',
            buttons: [
                { text: 'Cancel', role: 'cancel' },
                { text: 'Delete', role: 'destructive', handler: async () => {
                        try {
                            await actionToDeleteEventGalleryImage(id);
                            await loadGallery();
                        } catch (e) {
                            presentAlert({ header: 'Delete failed', message: e?.message || 'Please try again.', buttons: ['OK'] });
                        }
                    } }
            ]
        });
    };

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Manage Gallery</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <div className="gallery_manage_wrap">

                    <div className="upload_block">
                        <IonItem className="ion-no-padding ion-margin-bottom">
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={onPickFiles}
                                className="attach-pdf"
                            />
                        </IonItem>
                        {previewUrls.length > 0 && (
                            <div className="preview_grid">
                                {previewUrls.map((src, i) => (
                                    <div className="preview_thumb" key={i}>
                                        <img src={src} alt="" />
                                    </div>
                                ))}
                            </div>
                        )}
                        <IonButton onClick={onUpload} disabled={!files.length || loading}>
                            <IonIcon slot="start" icon={cloudUploadOutline} />
                            Upload {files.length ? `(${files.length})` : ''}
                        </IonButton>
                    </div>

                    <hr />

                    <div className="existing_block">
                        <h3 className="mb-2">Existing Images ({gallery.length})</h3>
                        {gallery.length === 0 ? (
                            <p>No images yet.</p>
                        ) : (
                            <div className="existing_grid">
                                {gallery.map((g) => (
                                    <div className="existing_card" key={g.id}>
                                        <img src={g.image_url} alt={g.caption || ''} />
                                        <button className="del_btn" onClick={() => onDelete(g.id)} title="Delete">
                                            <IonIcon icon={trashOutline} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                </div>

                <div className="editor-actions">
                    <IonButton expand="block" onClick={onClose}>
                        Close
                    </IonButton>
                </div>
            </IonContent>
        </IonModal>
    );
};

export default EventGalleryModal;